import { render, staticRenderFns } from "./SupervisorReportManagerWrapper.vue?vue&type=template&id=1815b1fa&"
import script from "./SupervisorReportManagerWrapper.vue?vue&type=script&lang=js&"
export * from "./SupervisorReportManagerWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports